import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'icon-lead-priority',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path opacity="0.5" d="M22 19H14M2 19H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path opacity="0.5" d="M12 17V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="12" cy="19" r="2" stroke="currentColor" stroke-width="1.5"/>
                <path d="M2 11C2 9.34315 3.34315 8 5 8H19C20.6569 8 22 9.34315 22 11C22 12.6569 20.6569 14 19 14H5C3.34315 14 2 12.6569 2 11Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5C22 6.65685 20.6569 8 19 8H5C3.34315 8 2 6.65685 2 5Z" stroke="currentColor" stroke-width="1.5"/>
                <path opacity="0.5" d="M13 5L19 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <path opacity="0.5" d="M13 11L19 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                <circle opacity="0.5" cx="6" cy="5" r="1" fill="currentColor"/>
                <circle opacity="0.5" cx="6" cy="11" r="1" fill="currentColor"/>
            </svg>
        </ng-template>
    `,
})
export class IconLeadPriorityComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
